<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        Fortune Games 2025
        <i class="mdi mdi-slot-machine-outline text-danger" ></i>
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          Product of 27th Gaming Group
        </div>
      </div>
    </div>
  </div>
</footer>
